import { Injectable, Injector } from '@angular/core';
import { StateContext, Guid, ImageMessage } from '@lcu/common';
import { UsersState } from './users-state.model';
import { MapMarker, UserMap } from '@lowcodeunit/lcu-map-common';
import { ItineraryModel } from '../../models/itinerary.model';
import { UserAlbum } from '../../models/user-album.model';
import { UserPhoto } from '../../models/user-photo.model';
import { TopListModel } from '../../models/top-list.model';
import { UserInfo } from '../../models/user-info.model';
import { ActivityModel } from '@lowcodeunit/lcu-map-common/lib/models/activity.model';

@Injectable({
  providedIn: 'root',
})
export class UsersStateContext extends StateContext<UsersState> {
  //  Fields
  protected state: UsersState;

  //  Properties

  //  Constructors
  constructor(protected injector: Injector) {
    super(injector);
  }

  //  API Methods

  public Ensure() {
    this.Execute({
      Arguments: {},
      Type: 'Ensure',
    });
  }

  public Load() {
    this.Execute({
      Arguments: {},
      Type: 'Load',
    });
  }

  public AddUserInfo(userInfo: UserInfo) {
    console.log('Addding: ', userInfo);

    this.Execute({
      Arguments: {
        UserInfo: userInfo,
      },
      Type: 'AddUserInfo',
    });
  }

  public EditUserInfo(userInfo: UserInfo) {
    console.log('Editing: ', userInfo);

    this.Execute({
      Arguments: {
        UserInfo: userInfo,
      },
      Type: 'EditUserInfo',
    });
  }

  public SetSelectedMap(mapId: Guid) {
    console.log('setting selected map to: ', mapId);

    this.Execute({
      Arguments: {
        MapID: mapId,
      },
      Type: 'SetSelectedMap',
    });
  }

  public AddSelectedLayer(layerId: string) {
    console.log('Adding map with ID: ', layerId);

    this.Execute({
      Arguments: {
        LayerID: layerId,
      },
      Type: 'AddSelectedLayer',
    });
  }

  public RemoveSelectedLayer(layerId: string) {
    console.log('Removing map with ID: ', layerId);

    this.Execute({
      Arguments: {
        LayerID: layerId,
      },
      Type: 'RemoveSelectedLayer',
    });
  }

  public ChangeExcludedCurations(UsersExcludedLocations: string) {
    console.log('hiding locations with Ids: ', UsersExcludedLocations);

    this.Execute({
      Arguments: {
        LocationIDs: UsersExcludedLocations,
      },
      Type: 'ChangeExcludedCurations',
    });
  }

  public AddMap(map: UserMap) {
    console.log('Adding Map: ', map);

    this.Execute({
      Arguments: {
        Map: map,
      },
      Type: 'AddMap',
    });
  }

  public DeleteMap(map: UserMap) {
    this.Execute({
      Arguments: {
        MapID: map.ID,
      },
      Type: 'DeleteMap',
    });
  }
  public DeleteMaps(mapIds: Array<any>) {
    console.log('deleting map with ids ', mapIds);
    this.Execute({
      Arguments: {
        MapIDs: mapIds,
      },
      Type: 'DeleteMaps',
    });
  }

  public AddAlbum(album: UserAlbum) {
    console.log('adding album ', album);

    const images = new Array<ImageMessage>();
    album.Photos.forEach((photo) => {
      console.log('photo = ', photo);
      const image = new ImageMessage();
      //changed image.DataString to image.Data
      image.DataString = photo.Image.Data;
      console.log('image.Data ', image.DataString);
      image.Headers = photo.Image.Headers.toString();
      image.Headers += '&ID=' + photo.ID;
      console.log('headers =', image.Headers);
      photo.Image = null;
      images.push(image);
    });
    console.log("album HERE: ", album);
    console.log("Images HERE: ", images)

    this.Execute({
      Arguments: {
        Album: album,
        Images: images
      },    
      Type: 'AddAlbum',
    });
  
  }

  public EditAlbum(album: UserAlbum) {
    console.log('editing album ', album);

    this.Execute({
      Arguments: {
        Album: album,
      },
      Type: 'EditAlbum',
    });
  }

  public DeleteAlbum(album: UserAlbum) {
    console.log('deleting album ', album);

    this.Execute({
      Arguments: {
        AlbumID: album.ID,
      },
      Images: [],
      Type: 'DeleteAlbum',
    });
  }

  public DeletePhoto(photo: UserPhoto) {
    console.log('deleting photo ', photo);

    this.Execute({
      Arguments: {
        PhotoId: photo.ID,
      },
      Type: 'DeletePhoto',
    });
  }

  public EditPhoto(album: UserAlbum, photo: UserPhoto) {
    this.Execute({
      Arguments: {
        AlbumID: album.ID,
        Photo: photo,
      },
      Type: 'EditPhoto',
    });
  }

  public AddPhoto(album: UserAlbum, photo: UserPhoto) {
    console.log('album passed in: ', album)
    const images = new Array<ImageMessage>();
      console.log('photo when adding = ', photo);
      const image = new ImageMessage();
      //changed image.DataString to image.Data
      image.DataString = photo.Image.Data;
      console.log('image.Data ', image.DataString);
      image.Headers = photo.Image.Headers.toString();
      image.Headers += '&ID=' + photo.ID;
      console.log('headers =', image.Headers);
      photo.Image = null;
      images.push(image);

    this.Execute({
      Arguments: {
        Album: album,
        Images: images
      },    
      Type: 'AddPhoto',
    });
  }

  public ChangeViewingArea(bounds: Array<number>) {
    this.Execute({
      Arguments: {
        Coordinates: bounds,
      },
      Type: 'ChangeViewingArea',
    });
  }

  public SendInvites(emails: Array<string>) {
    console.log('Inviting: ', emails);

    this.Execute({
      Arguments: {
        Emails: emails,
      },
      Type: 'SendInvites',
    });
  }

  public Search(searchTerm: string, userLayerIDArray?: any) {
    this.Execute({
      Arguments: {
        SearchTerm: searchTerm,
        UserLayerID: userLayerIDArray,
      },
      Type: 'Search',
    });
  }

  public AddTopList(topList: TopListModel) {
    this.Execute({
      Arguments: {
        TopList: topList,
      },
      Type: 'AddTopList',
    });
  }

  public EditTopList(topList: TopListModel) {
    this.Execute({
      Arguments: {
        TopList: topList,
      },
      Type: 'EditTopList',
    });
  }

  public DeleteTopList(topListID: any) {
    this.Execute({
      Arguments: {
        TopListID: topListID,
      },
      Type: 'DeleteTopList',
    });
  }

  //  Helpers
  protected defaultValue() {
    return { Loading: true } as UsersState;
  }

  protected loadStateKey(): string {
    return 'users';
  }

  protected loadStateName(): string {
    return 'amblon';
  }

  protected setupReceiveState(groupName: string) {
    this.rt.RegisterHandler(`ReceiveState=>${groupName}`).subscribe((req) => {
      console.log(`Handled state from ${groupName}`);
 
      this.subject.next(req);
    });
  }
}
